export default __webpack_public_path__ + "images/icons/social/logo_instagram.svg";